import { DATE_FORMATS } from "@/enums";
import { DatePicker as AntDatePicker, Space } from "antd";
import dayjs from "dayjs";
import { bool, func, node, object, string } from "prop-types";

export const ViperDatePicker = ({
  id,
  value,
  disabled = false,
  disabledDate,
  onFocus,
  onBlur,
  onChange,
  allowClear = true,
  defaultDate = dayjs().toString(),
  suffixIcon,
  renderExtraFooter,
}) => {
  const dateFormat = DATE_FORMATS.fourDigitYear;

  return (
    <Space>
      <AntDatePicker
        data-test-id={id}
        value={value}
        disabled={disabled}
        disabledDate={disabledDate}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        format={dateFormat}
        default={defaultDate}
        allowClear={allowClear}
        suffixIcon={suffixIcon}
        renderExtraFooter={renderExtraFooter}
        placeholder={dateFormat}
      />
    </Space>
  );
};

ViperDatePicker.propTypes = {
  id: string.isRequired,
  value: object,
  disabled: bool,
  disabledDate: func,
  onFocus: func,
  onBlur: func,
  onChange: func,
  allowClear: bool,
  defaultDate: string,
  suffixIcon: node,
  renderExtraFooter: func,
};
